import { createFileRoute, redirect } from '@tanstack/react-router'
import { BoostsListPage } from '@/pages/Boosts/BoostsListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/boosts')({
  component: BoostsListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/boosts')) {
      throw redirect({ to: '/' })
    }
  },
})
